if (!customElements.get('maak-loadout')) {
  customElements.define('maak-loadout', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const capacity = Number(this.dataset.capacity) || 10;
      const cards = [...this.querySelectorAll('[data-device]')].map(card => ({ card, quantity: 0, color: card.querySelector('[data-color]')?.dataset.color || '' }));
      const quote = this.querySelector('[data-quote]');
      const total = () => cards.reduce((sum, item) => sum + item.quantity, 0);
      const update = () => {
        const count = total();
        this.querySelector('[data-total]').textContent = count;
        cards.forEach(item => {
          item.card.querySelector('[data-quantity]').textContent = item.quantity;
          item.card.querySelector('[data-increase]').disabled = count >= capacity;
          item.card.querySelector('[data-decrease]').disabled = item.quantity === 0;
        });
        const lines = [`Loadout request — ${this.dataset.kit}`, '', `Base: 1× ${this.dataset.kit}`];
        const selected = cards.filter(item => item.quantity > 0);
        if (selected.length) {
          lines.push('EUDs:');
          selected.forEach(item => lines.push(`- ${item.quantity}× ${item.card.dataset.device} (${item.color})`));
          lines.push(`Total EUDs: ${count} / ${capacity} ${this.dataset.capacityLabel}`);
        } else lines.push('EUDs: none selected (kit only)');
        lines.push('', 'Name:', 'Organization:', 'Timeline:', 'Notes:');
        quote.href = `mailto:${this.dataset.email}?subject=${encodeURIComponent(this.dataset.subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
      };
      cards.forEach(item => {
        item.card.querySelector('[data-increase]').addEventListener('click', () => { if (total() < capacity) item.quantity++; update(); }, { signal });
        item.card.querySelector('[data-decrease]').addEventListener('click', () => { if (item.quantity > 0) item.quantity--; update(); }, { signal });
        item.card.querySelectorAll('[data-color]').forEach(button => button.addEventListener('click', () => {
          item.color = button.dataset.color;
          item.card.querySelectorAll('[data-color]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          update();
        }, { signal }));
      });
      const product = this.closest('moth-product');
      product.querySelectorAll('.moth-thumbs button').forEach(button => button.addEventListener('click', () => {
        product.querySelectorAll('.moth-slide video').forEach(video => video.pause());
      }, { signal }));
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
